import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { CSSForSelect, handleErrorToast } from '../../CustomFunctions';
import { AddwithWhiteCircle, DeleteDustbin, UpdatePencil } from '../../AllSvg';
import { Modal, ToastContainer } from 'react-bootstrap';
import Select from 'react-select';

const AddDefaultImprestType = ({ getImprestTypeFormat }) => {
    const [show, setShow] = useState(false)
    const handleShow = () => {
        getsubcompany();
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            other_name: "",
            sub_company: "",
        })
    }

    const [formData, setFormData] = useState({
        other_name: "",
        sub_company: "",
    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        let requiredFields = [
            "other_name",
            "sub_company",
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;

    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.post(`${BASE_URL}/siteproject/impresttype/`, formData);
                if (res.status === 200) {
                    await getImprestTypeFormat();
                    toast.success("Data Uploaded Successfully!")
                    toast.dismiss(loadingToastId);
                    handleClose();
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getsubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }

    const subcompanyOption = subcompanyList.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    return (
        <>
            <button className='upload-svg' title='Add Role' onClick={handleShow}>
                <AddwithWhiteCircle /> Imprest Type
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Add a Default Imprest Type
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <div className="flex-column">
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subcompanyOption}
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                            </div>
                            <div className="flex-column">
                                <div>
                                    <label htmlFor="other_name">Select Imprest Type Name</label>
                                    <input
                                        id="other_name"
                                        type="text"
                                        name="other_name"
                                        placeholder="Imprest Type Name"
                                        onChange={handleInputChange}
                                        value={formData.other_name}
                                        className={`form-input`}
                                    />
                                </div>
                                {errors.other_name && (
                                    <div className="error-message font-size-text">{errors.other_name}</div>

                                )}
                            </div>
                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    )

}

const UpdateDefaultImprestType = ({ i, getImprestTypeFormat }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        getsubcompany();
        setFormData(i);
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({
        other_name: "",
        sub_company: "",

    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const newErrors = {};
        const requiredFields = [
            "other_name", "sub_company"
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.put(`${BASE_URL}/siteproject/impresttype/${i.id}/`, formData);
                if (res.status === 200) {
                    await getImprestTypeFormat();
                    toast.success("Data Uploaded Successfully!")
                    toast.dismiss(loadingToastId);
                    handleClose();
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getsubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }

    const subcompanyOption = subcompanyList.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    return (
        <>
            <button className='model-edit-button' title='Update Role' onClick={handleShow}>
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Update Employee Role
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>

                            <div className="flex-column">
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subcompanyOption}
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                            </div>
                            <div className="flex-column">
                                <div>
                                    <label htmlFor="other_name">Select Imprest Type Name</label>
                                    <input
                                        id="other_name"
                                        type="text"
                                        name="other_name"
                                        placeholder="Imprest Type Name"
                                        onChange={handleInputChange}
                                        value={formData.other_name}
                                        className={`form-input`}
                                    />
                                </div>
                                {errors.other_name && (
                                    <div className="error-message font-size-text">{errors.other_name}</div>

                                )}
                            </div>
                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal>
        </>
    )
}

const DeleteDefaultImprestType = ({ i, getImprestTypeFormat }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Deleting: Please wait..."); //toast Logic
        setLoading(true);

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/impresttype/${i.id}/`
            );

            if (res.status === 200) {
                await getImprestTypeFormat();
                toast.success("Data Deleted Successfully");
                toast.dismiss(loadingToastId);
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete a Default Imprest Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete the default Imprest Type "{i.other_name}" of {i.subCompany_title}
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button model-button-delete font-weight500"
                                disabled={loading}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};

export { AddDefaultImprestType, UpdateDefaultImprestType, DeleteDefaultImprestType }